import { Dispatch, SetStateAction, useEffect } from 'react';

import { cn } from '@/utilities/cn';

interface IPopoverProps {
  showNotices: boolean;
  setShowNotices: Dispatch<SetStateAction<boolean>>;
  content: string;
}

const Popover = (props: IPopoverProps) => {
  const { showNotices, setShowNotices, content } = props;

  useEffect(() => {
    if (showNotices) {
      const timeout = setTimeout(() => {
        setShowNotices(false);
      }, 5000);

      return () => clearTimeout(timeout);
    }
  }, [setShowNotices, showNotices]);

  return (
    <div
      className={cn(
        'absolute top-full right-0 bg-white w-full shadow-xl rounded-lg z-50 px-3 py-2',
        'transition-opacity duration-300 ease-in-out md:w-64 overflow-hidden pointer-events-none',
        showNotices ? 'opacity-100' : 'opacity-0',
      )}
    >
      {content}
    </div>
  );
};

export default Popover;
